import { render, staticRenderFns } from "./AddServiceBundle.vue?vue&type=template&id=38e8888c&"
import script from "./AddServiceBundle.vue?vue&type=script&lang=js&"
export * from "./AddServiceBundle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddServiceBundle.vue"
export default component.exports